import api from './api';
import { mediaUrl } from './crmService';

export { mediaUrl };

// --- Vendors --------------------------------------------------------------
// filters: { q, supply_item_id, category, include_inactive }
export const listVendors = (filters = {}) => api.get('/vendors', { params: filters });

export const getVendor = (vendorId) => api.get(`/vendors/${vendorId}`);

export const createVendor = (payload) => api.post('/vendors', payload);

export const updateVendor = (vendorId, payload) => api.put(`/vendors/${vendorId}`, payload);

export const deleteVendor = (vendorId) => api.delete(`/vendors/${vendorId}`);

// --- Vendor contacts --------------------------------------------------------
export const addVendorContact = (vendorId, payload) => api.post(`/vendors/${vendorId}/contacts`, payload);

export const updateVendorContact = (vendorId, contactId, payload) =>
  api.put(`/vendors/${vendorId}/contacts/${contactId}`, payload);

export const deleteVendorContact = (vendorId, contactId) =>
  api.delete(`/vendors/${vendorId}/contacts/${contactId}`);

// --- Notes (the vendor's simple activity/notes log) ------------------------
export const addVendorNote = (vendorId, noteText) => api.post(`/vendors/${vendorId}/notes`, { note_text: noteText });

// --- Supply items (ad hoc catalog of what's bought FROM vendors - separate
// from the CRM's product catalog, see app/models.py's SupplyItem) ----------
export const listSupplyItems = () => api.get('/supply-items');

export const createSupplyItem = (name) => api.post('/supply-items', { name });

// --- Card scanning (reuses the CRM's vision pipeline, gated by this
// module's own access rule) -------------------------------------------------
export const scanVendorCard = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  // No explicit Content-Type - see api.js's 2026-09-13 comment on why
  // setting it here breaks the multipart boundary axios/the browser add
  // automatically for a FormData body.
  return api.post('/vendors/cards/scan', formData);
};

export const scanVendorCardsMulti = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/vendors/cards/scan-multi', formData);
};

export const getVendorScanJob = (jobId) => api.get(`/vendors/cards/scan-jobs/${jobId}`);

// job_id + card_index (multi-scan only) + fields + optional vendor_id to
// match an existing vendor instead of the automatic name lookup.
export const confirmVendorCard = (payload) => api.post('/vendors/cards/confirm', payload);

// --- XLS import (partial success - see app/routes/vendor_routes.py) -------
export const importVendors = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/vendors/import', formData);
};

export const downloadVendorsImportTemplate = () => api.get('/vendors/import-template', { responseType: 'blob' });
